import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-localstorage-backend'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import ja from './locales/ja.json'
import zh from './locales/zh.json'

i18n
  .use(Backend) // persists selected language in local storage
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    // Strip region variants (e.g. en-US → en, ja-JP → ja) so resource keys resolve correctly
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
